import Content from '@layout/Content'
import ColumnForm from './ColumnForm'
import ColumnResult from './ColumnResult'
import { ColumnProvider } from './context'

function ColumnPage () {
  return (
    <ColumnProvider>
      <Content
        renderInput={<ColumnForm />}
        renderOutput={<ColumnResult />}
      />
    </ColumnProvider>
  )
}

export default ColumnPage
